module.exports = __webpack_public_path__ + "img/s-dark.281ca594.svg";